(() => {
  if (window.PmlGemstoneSyncLoaded) return;
  window.PmlGemstoneSyncLoaded = true;
  const init = () => document.querySelectorAll('[data-pml-gemstone-sticky]').forEach((bar) => {
    if (bar.dataset.initialized) return;
    const info = document.querySelector(bar.dataset.productInfo);
    if (!info) return;
    bar.dataset.initialized = 'true';
    const product = info.closest('product-info');
    const button = bar.querySelector('[data-pml-sticky-button]');
    const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };
    const sync = () => {
      // Dawn replaces variant-selects after every response: always read the live node.
      const picker = info.querySelector('variant-selects');
      const mainButton = info.querySelector('.product-form__submit');
      const options = [...(picker?.querySelectorAll('input[type="radio"]:checked, select') || [])].map(x => x.value);
      setText(bar.querySelector('[data-pml-sticky-variant]'), options.join(' / '));
      const price = info.querySelector('[id^="price-"] .price:not(.price--on-sale) .price-item--regular, [id^="price-"] .price.price--on-sale .price-item--sale');
      if (price) setText(bar.querySelector('[data-pml-sticky-price]'), price.textContent.trim());
      const disabled = !mainButton || mainButton.disabled;
      if (button.disabled !== disabled) button.disabled = disabled;
      setText(button, disabled ? (mainButton?.textContent.trim() || 'Choose your options') : 'Add to bag');
      let variant;
      try { variant = JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { variant = null; }
      const fallback = product?.querySelector('[data-pml-petal-media]');
      const native = product?.querySelector('[data-pml-native-media]');
      if (fallback && native) {
        const petal = /^G-100496-[SML]$/.test(variant?.sku || '');
        fallback.hidden = !petal;
        native.hidden = petal;
      }
    };
    info.addEventListener('change', () => queueMicrotask(sync));
    new MutationObserver(sync).observe(info, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled']});
    button.addEventListener('click', () => {
      const mainButton = info.querySelector('.product-form__submit');
      if (mainButton && !mainButton.disabled) mainButton.click();
    });
    const mainButton = info.querySelector('.product-form__submit');
    if (mainButton) new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && innerWidth < 750;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
    }, {threshold:0.05}).observe(mainButton);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
